'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function () {
    (0, _templates.addTemplates)({

        couponArea: function couponArea(e) {
            if (!e.value || !e.value.length) return '-';
            return e.value.map(function (v) {
                return v.name;
            }).join(', ');
        },

        couponLink: function couponLink(e) {
            if (!e.value || !e.value.length) return '-';
            return e.value.map(function (v) {
                return '<a href="' + getCouponLink(v) + '">' + v.name + '</a>';
            }).join(', ');
        },

        couponValue: function couponValue(e) {
            if (!e.value || !e.value.value) return '-';
            return getCouponUnitValue(e.value);
        },

        edit: function edit(e) {

            return '<input data-editable-cell=' + e.value + ' class="editable-cell-text" data-editable-cell-complaintId=' + this.id + ' type="text" readonly value=' + e.value + '>' + ('<i data-editable-cell-icon=' + this.id + ' class="fa fa-pencil-square-o edit-cell-icon" aria-hidden="true"></i>');
        },

        authors: function authors(e) {
            return e.value.map(function (v) {
                return '<a href="' + (0, _config2.default)().url.author({ id: v.id }) + '" title="' + v.type + '">' + v.name + '</a>';
            }).join(', ');
        },

        authorsWithoutLink: function authorsWithoutLink(e) {
            return e.value ? e.value.map(function (v) {
                return '<span>' + v.name + '</a>';
            }).join(', ') : null;
        },

        orderState: function orderState(e) {

            var item = e.column.enumValue(e.value) || { id: -1, text: "undefined" };
            var cssClass = ['x', 'star', 'cog orange', 'gears orange', 'truck green', 'check blue', 'exclamation-triangle yellow'][item.id];
            return '<i class="fa fa-' + cssClass + '" data-toggle="tooltip" data-placement="right" data-original-title="' + item.text + '"></i>';
        },

        orderItemState: function orderItemState(e) {
            var item = e.column.enumValue(e.value) || { id: -1, text: "undefined" };
            var cssClass = ['x', 'asterisk', 'cog orange', 'gears orange', 'truck green', 'check blue', 'exclamation-triangle yellow'][item.id];
            return '<i class="fa fa-' + cssClass + '" data-toggle="tooltip" data-placement="right" data-original-title="' + item.text + '"></i>';
        },

        visualTrueFalse: function visualTrueFalse(e) {
            var cssClass = e.value ? 'check green' : 'remove red';
            return '<i class="fa fa-' + cssClass + '"></i>';
        },

        language: function language(e) {
            return e ? e.reference : '';
        },

        paymentState: function paymentState(e) {
            return '' + resx.App[e.value];
        },

        undoExpiredOrderButton: function undoExpiredOrderButton() {
            return '<a data-control-button-undo-expired-order="' + this.id + '" data-confirm="' + resx.Messages.ConfirmUndoExpiredOrder + '" data-confirm-title="' + resx.Messages.ConfirmTitle + '" class="remove" href="#">\n                    <i class="fa fa-undo" data-toggle="tooltip" data-original-title="' + resx.Common.Reload + ' ' + this.reference + '"></i>\n                </a>';
        },

        deleteButton: function deleteButton() {
            return '<a data-control-button-delete="' + this.id + '" data-confirm="' + resx.Messages.ConfirmDelete + '" data-confirm-title="' + resx.Messages.ConfirmTitle + '" class="remove" href="#">\n              <i class="fa fa-remove"></i>\n              </a>';
        },

        unblockButton: function unblockButton() {
            return (0, _lodash.isNumber)(this.orderedAmount) && this.orderedAmount > 0 ? '<a data-control-button-unblock="' + this.id + '" data-control-button-unblock-dist-channel-id="' + this.distributionChannelId + '" data-confirm="' + resx.Messages.ConfirmUnblock + '" data-confirm-title="' + resx.Messages.ConfirmTitle + '" class="remove" href="#">\n                    <i class="fa fa-undo"></i>\n                  </a>' : '&nbsp;';
        },

        orderDetail: function orderDetail() {
            return (0, _lodash.isNumber)(this.orderedAmount) && this.orderedAmount > 0 ? '<a data-control-button-order-detail="' + this.id + '" data-control-button-order-detail-dist-channel-id="' + this.distributionChannelId + '" class="" href="#">' + this.orderedAmount + '&nbsp;<i class="fa fa-caret-down"></i></a>' : '0';
        },

        deleteFileManagerButton: function deleteFileManagerButton(e) {
            var visible = e.data["isDeletable"];
            if (visible) {
                var type = e.data["type"];
                var message = resx.Messages.ConfirmDelete;
                if (type === "Folder") {
                    message += '\n' + resx.Messages.ConfirmDeleteFolder;
                } else {
                    message += '\n' + resx.Messages.ConfirmDeleteFile;
                }

                return '<a data-control-button-filemanager-delete="' + this.id + '" data-control-button-filemanager-delete-type="' + type + '" data-confirm="' + message + '" data-confirm-title="' + resx.Messages.ConfirmTitle + '" class="remove" href="#">\n              <i class="fa fa-remove"></i>\n              </a>';
            }

            return '<a/>';
        },

        deleteTranslationButton: function deleteTranslationButton(e) {
            if (this.key.indexOf('#') === -1) {
                return null;
            }

            return '<a data-control-button-delete="' + this.id + '" data-confirm="' + resx.Messages.ConfirmDelete + '\n" data-confirm-title="' + resx.Messages.ConfirmTitle + '" class="remove" href="#">\n              <i class="fa fa-remove"></i>\n              </a>';
        },

        downloadDeliveryNote: function downloadDeliveryNote(e) {
            return '<a href="' + linksoft.url.downloadDeliveryNote(this) + '" title="' + resx.App.DownloadExcel + '">\n                <i class="fa fa-file-excel-o"></i>\n                </a>';
        },

        productPriority: function productPriority(e) {
            if (e.value > 0) {
                return '<input type="number" class="product-priority-editor" name="priority" min="1" value="' + e.value + '" product-priority-value product-priority-id="' + this.id + '"/>';
            }
            return '<input type="number" name="quantity"  class="product-priority-editor" min="1" product-priority-value product-priority-id="' + this.id + '"/>';
        },

        downloadExcel: function downloadExcel(e, urlName) {
            return '<a href="' + linksoft.url[urlName](this) + '" title="' + resx.App.DownloadExcel + '"><i class="fa fa-file-excel-o"></i></a>';
        },

        userNullableLink: function userNullableLink(e, urlName) {
            var user = this.userId;
            if (user) {
                return '<a href="' + linksoft.url[urlName]({ id: user }) + '">' + this.userName + '</a>';
            } else {
                return this.userName;
            }
        },

        productListItemsDelete: function productListItemsDelete(data) {
            var typeString = fillProductListType('series', data.value);
            typeString += fillProductListType('editions', data.value);
            typeString += fillProductListType('authors', data.value);
            typeString += fillProductListType('brands', data.value);

            return typeString.trim().length === 0 ? '<a href="#" data-product-lists-action-delete="true"><i class="fa fa-remove"></i></a>' : '<span></span>';
        },

        productListType: function productListType(data) {
            var typeString = fillProductListType('series', data.value, resx.App.Series2);
            typeString += fillProductListType('editions', data.value, resx.App.Edition);
            typeString += fillProductListType('authors', data.value, resx.Common.Author);
            typeString += fillProductListType('brands', data.value, resx.Common.Brands);
            return '<span>' + typeString + '</span>';
        },

        download: function download(e, urlName, title) {
            var hasFileName = this.hasFileName;
            if (hasFileName) {
                return '<a invoice-id=' + this.id + ' href="' + linksoft.url[urlName](this) + '" title="' + title + '"><i class="fa fa-download"></i></a>';
            } else {
                return "";
            }
        },

        sendNewsletterCheckbox: function sendNewsletterCheckbox(e) {
            return '<input type="checkbox" ' + (e.value ? "checked=\"checked\"" : "") + ' id="dt-sendnewsletter-' + this.id + '" data-user-sendnewsletter="true" data-userid="' + this.id + '"/>\n                <label for="dt-sendnewsletter-' + this.id + '"></label>';
        },

        packages: function packages(e) {
            if (Array.isArray(e.value)) {
                return e.value.map(function (x) {
                    return createPackageLink(x);
                }).join(e.formatString || '');
            }

            var dto = assign({}, _typeof(e.value) === 'object' ? e.value : {
                trackingNumber: e.value,
                urlTemplate: e.value,
                name: e.value
            });
            return createInvoiceLink(dto);
        },

        salesStats: function salesStats(e) {
            return '<span title="' + resx.App.AfterDays_After + ' 30 ' + resx.App.AfterDays_Days + '">' + e.value.amount1 + '</span>' + '&nbsp;|&nbsp;' + ('<span title="' + resx.App.AfterDays_After + ' 60 ' + resx.App.AfterDays_Days + '">' + e.value.amount2 + '</span>') + '&nbsp;|&nbsp;' + ('<span title="' + resx.App.AfterDays_After + ' 90 ' + resx.App.AfterDays_Days + '">' + e.value.amount3 + '</span>');
        },

        deliveryMethod: function deliveryMethod(e) {
            return e.value ? '<span class="product-icon product-icon-k product-icon--small" data-toggle="tooltip" data-original-title="' + resx.App.DeliveryMethod_Commission + '"></span>' : '<span class="product-icon product-icon-f product-icon--small" data-toggle="tooltip" data-original-title="' + resx.App.OnlyInvoice + '"></span>';
        },

        invoiceLink: function invoiceLink(e, urlName) {
            if (Array.isArray(e.value)) {
                return e.value.map(function (x) {
                    return createInvoiceLink(urlName, x);
                }).join(e.formatString || '');
            }

            var args = {};
            if (typeof key === 'string') {
                args.id = this[key];
            }

            var dto = assign({}, _typeof(e.value) === 'object' ? e.value : {
                id: e.value,
                name: e.value,
                hasFileName: e.value
            }, args);
            return createInvoiceLink(urlName, dto);
        },

        createComplaint: function createComplaint(e) {
            return '<a href="Complaint/New/' + e + '">new</a>';
        },

        checkBox: function checkBox(e) {
            return '<span>' + e.value + '</span>';
        },

        complaintAmount: function complaintAmount(e) {
            return '<input class="input-complaint col-sm-4 pull-right" type="text" data-complaint-amount data-productId=' + e.value + ' />';
        },

        singleInvoiceLink: function singleInvoiceLink(e, urlName) {
            var dto = assign({}, { id: this.id, name: e.value, hasFileName: this.hasFileName });
            return createInvoiceLink(urlName, dto);
        },

        eanLink: function eanLink(e) {
            return e.value ? '<a href="' + (0, _config2.default)().url.product({ id: this.productId }) + '">' + e.value + '</a>' : '<span>' + e.value + '</span>';
        },

        showPosition: function showPosition(e) {
            return e.value && e.value !== "," ? '<a href="#" data-position=\'' + e.value + '\'><i class="fa fa-map-marker"></i> ' + resx.App.Show + '</a>' : '<span> - </span>';
        },

        statusIndicator: function statusIndicator(e) {
            return e.value ? '<div class="onlineIndicator" />' : '<div class="offlineIndicator" />';
        },

        timeSpan: function timeSpan(e) {
            if (e.value) {
                // about to parse ISO 8601 Timespan
                var minutes = 0;
                var hours = 0;
                var parsedDays = e.value.match(/(\d+)\s*D/);
                var parsedHours = e.value.match(/(\d+)\s*H/);
                var parsedMinutes = e.value.match(/(\d+)\s*M/);
                if (parsedDays) {
                    hours += parseInt(parsedDays[1]) * 24;
                }
                if (parsedHours) {
                    hours += parseInt(parsedHours[1]);
                }
                if (parsedMinutes) {
                    minutes = parseInt(parsedMinutes[1]);
                }
                return '<span>' + hours + 'h ' + minutes + 'm</span>';
            } else {
                return '<span> - </span>';
            }
        },

        userVisibilitySwitchButton: function userVisibilitySwitchButton(e, type) {
            var active = type === 1 ? this.isLogged : type === 2 ? this.isAnonymous : false;
            return '<div class="cell-edit--wrap">&nbsp;<div class="cell-edit-inner">' + ('<a data-control-isLogged="' + this.isLogged + '" data-control-isAnonymous="' + this.isAnonymous + '" data-control-type="' + type + '" data-control-switch-user-visibility-id="' + this.id + '" class="visible ' + (active ? "visible-dis" : "") + ' " href="#"><i class="fa"></i></a>') + '</div></div>';
        },

        switchButton: function switchButton(e) {
            return '<div class="cell-edit--wrap">&nbsp;<div class="cell-edit-inner">' + ('<a data-control-switch-id="' + this.id + '" data-control-value="' + e.value + '" data-control-name="' + e.column.name() + '" class="visible ' + (e.value ? "visible-dis" : "") + ' " href="#"><i class="fa"></i></a>') + '</div></div>';
        },

        controlButtons: function controlButtons(e, editUrl, showCopy, showCopyWithSelect, showIsActiveSwitch, showRemove) {
            return '<div class="cell-edit--wrap">&nbsp;<div class="cell-edit-inner">'

            // edit
            + (editUrl ? '<a class="edit" title="' + resx.Common.Edit + '" href="' + linksoft.url[editUrl](this) + '"><i class="fa fa-edit"></i></a>' : "")

            //showCopy
            + (showCopy ? '<a class="copy" data-confirm="' + resx.Common.ConfirmCopy + '" data-control-button-copy="' + this.id + '" title="' + resx.Common.Copy + '" href=""><i class="fa fa-copy"></i></a>' : "") + (showCopyWithSelect ? '<a class="copy" data-toggle="modal" data-target="#copy-item" data-control-button-copy-select="' + this.id + '" href=""><i class="fa fa-copy"></i></a>' : '')

            // active switch
            + (showIsActiveSwitch && typeof this.isActive !== 'undefined' ? '<a data-control-button-is-active="' + this.isActive + '" data-control-button-is-active-item-id="' + this.id + '" class="visible ' + (this.isActive ? "visible-dis" : "") + '" href="#"><i class="fa"></i></a>' : "")

            // // remove
            //+ (showRemove
            //? `<a data-control-button-delete="${this.id}" data-confirm="Common.ConfirmDelete" class="remove" href="#"><i class="fa fa-remove"></i></a>`
            //: "")


            // level down filter
            //+ `<a class="down" href=""><i class="fa fa-level-down"></i></a>`


            + '</div>'

            // left active bar
            + (typeof this.isActive !== 'undefined' ? '<div class="is-active ' + (this.isActive ? "is-active-yes" : "is-active-no") + '"></div>' : "") + '</div>';
        },

        productWatchDogs: function productWatchDogs(e, key) {
            return '<div class="text-center">' + ('<span>' + e.value + '</span>&nbsp;') + ('<a class="copy" data-toggle="modal" data-target="#copy-watch-dogs" data-control-button-copy-select="' + this.id + '" href="">') + ('<i class="fa fa-chevron-right blue" data-toggle="tooltip" data-original-title="' + resx.App.CopyWatchDogInfo + '"></i>') + '</a>' + '</div>';
        },

        truncate: function truncate(e, length) {
            return e.value.length > length ? e.value.substring(0, length) + "..." : e.value;
        },

        productDetailLink: function productDetailLink(e) {
            return '<a href=\'' + this.productDetailUrl + '\' target=\'_blank\'>' + this.productName + '</a>';
        },

        picture: function picture(e) {
            return e.value ? '<div class="image" style="height:70px"><img alt="image" class="img-responsive center-block" src="' + e.value + '"></div>' : "";
        },

        editModalButton: function editModalButton(e, editUrl) {
            var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return e.value ? '<a href="' + linksoft.url[editUrl]({ id: this.id }) + '" ' + attributes + '>' + e.value + '</a>' : '<span>' + e.value + '</span>';
        },

        loadContentLink: function loadContentLink(e, loadTarget, targetPath) {
            return (0, _loadContentLink2.default)(e.data["id"], e.value, loadTarget, targetPath);
        },

        fileManagerAdminName: function fileManagerAdminName(e, editUrl) {
            var type = e.data["type"];
            var id = e.data["id"];
            if (type === "File") {
                if (e.data.fileManagerType === 1) return '<span class=\'thumbnail-hover\' data-toggle=\'thumbnail-hover\' data-target=' + e.data.thumbnailUrl + ' data-title=' + e.data.name + '>' + e.value + '</span>';
                return '<span>' + e.value + '</span>';
            }
            return '<a href="' + linksoft.url[editUrl]({ id: id }) + '">' + e.value + '</a>';
        },

        fileManagerName: function fileManagerName(e, modalSelector, targetPath, imageType, loadTarget, idTargetSelector, isMultiple) {
            var type = e.data["type"];
            var id = e.data["id"];
            if (type === "File") {
                var imageOrFile = 'File';
                if (imageType !== 'File') {
                    imageOrFile = 'Image';
                }

                var payload = {
                    FileImageType: imageType
                };
                payload[imageOrFile] = {
                    Id: id,
                    Name: e.data["name"],
                    Size: e.data["size"],
                    Url: e.data["url"],
                    Guid: e.data["guid"]
                };

                if (imageType !== 'File') {
                    payload[imageOrFile].ThumbnailUrl = e.data["thumbnailUrl"];
                }

                var thumbnailHoverSpan = '<span class=\'thumbnail-hover\' data-toggle=\'thumbnail-hover\' data-target=' + e.data.thumbnailUrl + ' data-title=' + e.data.name + '>' + e.value + '</span>';

                return isMultiple ? (0, _loadContentLink2.default)(id, thumbnailHoverSpan, '#' + loadTarget, '/FileManager/' + imageOrFile + 'Draggable', payload, '#' + idTargetSelector, '#' + modalSelector, isMultiple) : (0, _loadContentLink2.default)(id, thumbnailHoverSpan, '#' + loadTarget, '/FileManager/Image', payload, '#' + idTargetSelector, '#' + modalSelector, isMultiple);
            } else {
                // folder updatne sam seba (obsah modal okna)
                return (0, _loadContentLink2.default)(id, e.value, '#' + modalSelector + ' .modal-content', targetPath + '?folderId=' + id + '&fileImageType=' + imageType, isMultiple);
            }
        },

        fileManagerType: function fileManagerType(e) {
            var type = e.value;
            var ext = e.data["extension"] || "";
            if (type === "File") {
                ext = ext.substring(1);
                return '<span class=\'image-gallery-ico\'><img src=\'/Content/images/svg/files/' + (0, _iconManager2.default)(ext) + '.svg\'></img></span>';
            } else {
                return '<span class=\'image-gallery-ico\'><img src=\'/Content/images/svg/files/folder.svg\'></img></span>';
            }
        },

        fileManagerUrl: function fileManagerUrl(e) {
            var type = e.data["type"];
            var url = e.value;
            var result = "<span/>";
            if (type === "File") {
                result = '\n                    <span style="cursor: pointer;" data-copy-to-clipboard="' + url + '">\n                        <i class="fa fa-clipboard"></i>\n                    </span>';
            }
            return result;
        },

        price: function price(e, priceType) {
            return (0, _linksoftAlbatros.formatPrice)(e.value, priceType);
        },

        htmlEncodedText: function htmlEncodedText(e) {
            return $('<div/>').text(e.value).html();
        },

        changeSerialNumber: function changeSerialNumber(e, dlgUrl) {
            var targetUrl = linksoft.url[dlgUrl]({
                productCmsPageId: this.productCmsPageId,
                orderItemProductSerialNumberId: this.id,
                serialNumberId: this.productSerialNumberId
            });

            return '<a href="' + targetUrl + '" data-toggle="modal" data-target="#changeSerialNumberDlg">' + resx.App.ChangeSerialNumber + '<a/>';
        },

        fileSize: function fileSize(e, emptyResult) {
            if (emptyResult && e.value === 0) {
                return emptyResult;
            }

            var bytes = e.value;
            var thresh = 1024;
            if (Math.abs(bytes) < thresh) {
                return bytes + " B";
            }
            var units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

            var u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while (Math.abs(bytes) >= thresh && u < units.length - 1);
            return bytes.toFixed(1) + " " + units[u];
        },

        alternativePickupPlaceActions: function alternativePickupPlaceActions(e) {
            if (!e.data.showActions) {
                return '';
            }
            var beginning = '<i class="fa fa-check green alternative-pp-button alternative-pp-confirm" data-alternative-pp-id="' + e.value + '"></i>';
            return beginning + ' <i class="fa fa-close red alternative-pp-button alternative-pp-cancel"  data-alternative-pp-id="' + e.value + '"></i>';
        },
        orderLink: function orderLink(e) {
            return '<a href="/OrderB2C/Detail/' + e.data.orderId + '">' + e.value + '</a>';
        },
        customerLink: function customerLink(e) {
            return '<a href="/Customer/Detail/' + e.data.customerId + '">' + e.value + '</a>';
        }
    });

    function createInvoiceLink(urlName, args) {
        var fn = (0, _config2.default)().url[urlName];
        var url = "javascript:void(0)";
        if (typeof fn === 'function') {
            url = fn(args);
        } else {
            abp.log.error('Function window.linksoft.url.' + urlName + ' is missing.');
        }
        if (args.hasFileName) {
            return '<a invoice-id=' + args.id + ' href="' + url + '">' + args.name + '</a> ';
        } else {
            return '<span>' + args.name + '</span> ';
        }
    }

    function createPackageLink(pack) {
        var url = pack.urlTemplate;
        var trackingNumber = pack.trackingNumber;
        var name = pack.name;
        var link = "";

        if (url) {
            var first = url.substring(0, url.indexOf('{'));
            var second = url.substring(url.indexOf('}') + 1);
            if (second) {
                link = first + trackingNumber + second;
            } else {
                link = first + trackingNumber;
            }
            if (trackingNumber && name) {
                return '<span class="sep"></span><a target="_blank" href="' + link + '">' + name + '</a>';
            } else if (name) {
                return '<span>' + name + '</span>';
            } else {
                return '<span> - </span>';
            }
        } else if (name) {
            return '<span>' + name + '</span>';
        } else {
            return '<span> - </span>';
        }
    }

    function getCouponUnitValue(unit) {
        switch (unit.type) {
            case 'Currency':
                return (0, _linksoftAlbatros.formatPrice)(unit.value, _linksoftAlbatros.PriceType.CatalogUnitPrice);
            case 'Percentage':
                return unit.value + ' %';
        }
        return '-';
    }

    function getCouponLink(target) {
        switch (target.target) {
            case 'Product':
                return (0, _config2.default)().url.product({ id: target.id });
            case 'Author':
                return (0, _config2.default)().url.author({ id: target.id });
        }
        return 'javascript:void(0)';
    }

    function fillProductListType(dataParamName, productId, title) {
        try {
            var dataElement = document.getElementById('productListDataSource');
            var entryArray = JSON.parse(dataElement.dataset[dataParamName]);
            var typeString = '';

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = entryArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var entry = _step.value;

                    if (!entry.Products) continue;

                    if (entry.Products.some(function (p) {
                        return p.Id === productId;
                    })) {
                        typeString += '' + (typeString.length === 0 ? '' : ', ') + title + ': ' + entry.Name;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return typeString;
        } catch (e) {
            console.error('Error in fillProductListType (table-templates) function', e);
        }
    }
};

var _templates = require('linksoft/data-tables/templates');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

var _linksoftAlbatros = require('linksoft-albatros');

var _loadContentLink = require('./loadContentLink');

var _loadContentLink2 = _interopRequireDefault(_loadContentLink);

var _iconManager = require('./iconManager');

var _iconManager2 = _interopRequireDefault(_iconManager);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Messages", "App", "Common");


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/table-templates.js
// module id = 455
// module chunks = 0